<mat-expansion-panel [togglePosition]="'before'" (opened)="opened()">
    <mat-expansion-panel-header>
    <mat-panel-title>
        Attorney or Agent Information
    </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="p-4">
    <!-- Attorney or Agent Information -->
    <form [formGroup]="attorneyInfoForm">        
        <div class="row">
            <h5 class="col-md-8 labelText"> Attorney or Agent Information </h5>      
            <div class="col-md-4 d-flex justify-content-end" *ngIf="isDuplicateLCA">
                <button class="clear-data-button" (click)="clearData()">
                    <i class="fa fa-repeat"></i> Clear Data
                 </button>
            </div>
        </div>
        <div class="row">
            <!-- Is the employer represented by an attorney or agent -->
            <div class="form-group slider-toggle col-md-12">
                <h6>Is the employer represented by an attorney or agent in the filing of this application?
                    <mat-slide-toggle class="vertically-middle"
                                      formControlName="enableAttorney"
                                      (change)="onChangeEnableAttorney($event.checked)">
                    </mat-slide-toggle>
                </h6>  
            </div>
        </div>
        <ng-container *ngIf="attorneyInfoForm.get('enableAttorney').value === true">

            <div class="row"> 
                <!-- Law Firm Name -->
                <div class="form-group col-md-4">
                    <mat-form-field> 
                        <label class="label-cls required">Law Firm Name</label>
                        <mat-select name="firmName"
                                    formControlName="firmName"
                                    (selectionChange)="onChangeLawFirmName($event.value)">
                          <mat-option *ngFor="let item of listLawFirm" [value]="item.companyId">
                            {{item.companyName}}
                          </mat-option> 
                        </mat-select>
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('firmName').invalid && attorneyInfoForm.get('firmName').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </mat-form-field>
                </div>
                <!-- Attorney/ Agent Name -->
                <div class="form-group col-md-4">
                    <mat-form-field> 
                        <label class="label-cls required">Attorney/ Agent Name</label>
                        <mat-select name="attorneyName"
                                    formControlName="attorneyName"
                                    (selectionChange)="onChangeAttorneyList($event.value)">
                          <mat-option *ngFor="let item of listAttorney" [value]="item.id">
                            {{item.userFullName}}
                          </mat-option> 
                        </mat-select>
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('attorneyName').invalid && attorneyInfoForm.get('attorneyName').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-2">
                <!-- Agent First Name -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Agent/ Attorney First Name (Given)</label>
                    <input class="im-input"
                            name="agentFirstName"
                            formControlName="agentFirstName"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message" 
                            *ngIf="(attorneyInfoForm.get('agentFirstName').touched  && attorneyInfoForm.get('agentFirstName').invalid) || (attorneyInfoForm.get('agentFirstName').touched && attorneyInfoForm.get('agentFirstName').errors?.required)"> 
                    {{ getGlobalErrorMessages("INVALID_NAME") }}
                    </span> 
                </div>
                <!-- Agent Middle Name -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls">Agent/ Attorney Middle Name</label>
                    <input class="im-input"
                            name="agentMiddleName"
                            formControlName="agentMiddleName"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message" 
                            *ngIf="(attorneyInfoForm.get('agentMiddleName').touched  && attorneyInfoForm.get('agentMiddleName').invalid)">
                    {{ getGlobalErrorMessages("INVALID_NAME") }}
                    </span> 
                </div>
                <!-- Agent Last Name (Family Name) -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Agent/ Attorney Last Name (Family Name)</label>
                    <input class="im-input"
                            name="agentLastName"
                            formControlName="agentLastName"
                            type="text"
                            placeholder="Enter" />
                    <span class="invalid-message" 
                            *ngIf="(attorneyInfoForm.get('agentLastName').touched  && attorneyInfoForm.get('agentLastName').invalid)  || (attorneyInfoForm.get('agentLastName').touched && attorneyInfoForm.get('agentLastName').errors?.required)">
                    {{ getGlobalErrorMessages("INVALID_NAME") }}
                    </span>
                </div>
            </div>
            <div class="row">
                <!-- Address 1 -->
                <div class="form-group col-md-6">
                    <label class="control-lbl mt-2 required label-cls">Address 1</label>
                    <input class="im-input"
                            type="text" 
                            name="addressLine1"
                            formControlName="addressLine1"
                            placeholder="Enter" />
                    <mat-hint>Ex. : Street Name & Number</mat-hint>
                    <span class="invalid-message"
                        *ngIf="(attorneyInfoForm.get('addressLine1').touched && attorneyInfoForm.get('addressLine1').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>
            <div class="row">
                <!-- Address 2 -->
                <div class="form-group col-md-6">
                    <label class="control-lbl mt-2 label-cls">Address 2</label>
                    <input class="im-input" 
                            type="text" 
                            name="addressLine1"
                            formControlName="addressLine1"
                            placeholder="Enter" />
                    <mat-hint>Ex. : Apartment., Suite, Building</mat-hint>
                </div>
            </div>
            <div class="row  mt-2"> 
                <!-- Country -->
                <div class="form-group col-md-4">
                    <mat-form-field> 
                        <label class="label-cls required">Country</label>
                        <mat-select name="country"
                                    formControlName="country"
                                    (selectionChange)="onChangeCountry($event.value)">
                          <mat-option *ngFor="let item of listCountry" [value]="item.countryCode">
                            {{item.countryName}}
                          </mat-option>  
                        </mat-select>
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('country').touched && attorneyInfoForm.get('country').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </mat-form-field>
                </div>
                <!-- State -->
                <div class="form-group col-md-4">
                    <mat-form-field> 
                        <label class="label-cls required">State</label>
                        <mat-select name="state"
                                    formControlName="state">
                          <mat-option *ngFor="let item of listStates" [value]="item.stateProvinceCode">
                            {{item.stateProvinceName}}
                          </mat-option> 
                        </mat-select>
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('state').touched && attorneyInfoForm.get('state').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </mat-form-field>
                </div>
                <!-- City -->
                <div class="form-group col-md-4">
                    <label class="col-md-12 required label-cls">City</label>
                    <input class="im-input"
                            name="city"
                            formControlName="city"
                            type="text"v
                            placeholder="Enter"/>
                    <span class="invalid-message"
                        *ngIf="(attorneyInfoForm.get('city').touched  && attorneyInfoForm.get('city').invalid) || (attorneyInfoForm.get('city').touched && attorneyInfoForm.get('city').errors?.required)">
                        {{ getGlobalErrorMessages("INVALID_CITY") }}
                    </span>
                </div>
            </div>
            <div class="row  mt-2">
                <!-- ZIP / Postal Code -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">ZIP / Postal Code</label>
                    <input class="im-input"
                            name="postalCode"
                            formControlName="postalCode"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message"
                        *ngIf="(attorneyInfoForm.get('postalCode').touched && attorneyInfoForm.get('postalCode').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <!-- Province -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls">Province</label>
                    <input class="im-input"
                            name="stateProvinceName"
                            formControlName="stateProvinceName"
                            type="text"
                            placeholder="Enter"/>
                </div>
                <!-- Extension -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls">Extension</label>
                    <input class="im-input"
                            name="extension"
                            formControlName="extension"
                            type="text"
                            placeholder="Enter" />
                    <span class="invalid-message" 
                            *ngIf="(attorneyInfoForm.get('extension').touched  && attorneyInfoForm.get('extension').invalid)">
                    {{ getGlobalErrorMessages("INVALID_EXTENSION") }}
                    </span>
                </div>
            </div> 
            <div class="row mt-2">
                <!-- Telephone Number -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Telephone Number</label>
                    <input class="im-input"
                            name="telephone"
                            formControlName="telephone"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message"
                        *ngIf="(attorneyInfoForm.get('telephone').touched && attorneyInfoForm.get('telephone').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
                <!-- Email ID -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Email ID</label>
                    <input class="im-input"
                            name="emailId"
                            formControlName="emailId"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message" *ngIf="(attorneyInfoForm.get('emailId').touched  && attorneyInfoForm.get('emailId').invalid) || (attorneyInfoForm.get('emailId').touched && attorneyInfoForm.get('emailId').errors?.required)">
                        {{ getGlobalErrorMessages("INVALID_EMAIL") }}
                    </span>
                </div>
                <!-- Law firm/Business Name -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">Law firm/Business Name</label>
                    <input class="im-input"
                            name="LawFirmName"
                            formControlName="LawFirmName"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message" *ngIf="(attorneyInfoForm.get('LawFirmName').touched  && attorneyInfoForm.get('LawFirmName').invalid) || (attorneyInfoForm.get('LawFirmName').touched && attorneyInfoForm.get('LawFirmName').errors?.required)">
                        {{ getGlobalErrorMessages("INVALID_NAME") }}
                    </span>
                </div>
            </div>
            <div class="row mt-2">
                <!-- Law firm/Business FEIN -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls">Law firm/Business FEIN</label>
                    <input class="im-input"
                            name="firmFEIN"
                            formControlName="firmFEIN"
                            type="text"
                            placeholder="Enter"/>
                </div>
                <!-- State Bar Number (Only if attorney) -->
                <div class="form-group col-md-4"> 
                    <label class="label-cls required">State Bar Number (Only if attorney)</label>
                    <input class="im-input"
                            name="attorneyStateBarNo"
                            formControlName="attorneyStateBarNo"
                            type="text"
                            placeholder="Enter"/>
                    <span class="invalid-message"
                        *ngIf="(attorneyInfoForm.get('attorneyStateBarNo').touched && attorneyInfoForm.get('attorneyStateBarNo').errors?.required)">
                        {{ getGlobalErrorMessages("REQUIRED") }}
                    </span>
                </div>
            </div>
            <div class="row">
                <!-- State of highest court -->
                <div class="form-group col-md-6">
                    <!-- <label class="control-lbl mt-2 label-cls">State of highest court where attorney is in good standing (only if attorney)</label>
                    <input class="im-input"
                            type="text" 
                            name="attorneyStateOfHighestCourt"
                            formControlName="attorneyStateOfHighestCourt"
                            placeholder="Enter" /> -->

                    <mat-form-field> 
                        <label class="control-lbl mt-2 label-cls required">State of highest court where attorney is in good standing (only if attorney)</label>
                        <mat-select name="attorneyStateOfHighestCourt"
                                    formControlName="attorneyStateOfHighestCourt">
                            <mat-option *ngFor="let item of listStatesHighest" [value]="item.stateProvinceCode">
                            {{item.stateProvinceName}}
                            </mat-option>
                        </mat-select>
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('attorneyStateOfHighestCourt').touched && attorneyInfoForm.get('attorneyStateOfHighestCourt').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                    </mat-form-field>
                </div> 
            </div>
            <div class="row">
                <!-- State of highest state -->
                <div class="form-group col-md-6">
                    <label class="control-lbl mt-2 label-cls required">Name of the highest State court where attorney is in good standing (only if attorney)</label>
                    <input class="im-input"
                            type="text" 
                            name="attorneyNameOfHighestStartCourt"
                            formControlName="attorneyNameOfHighestStartCourt"
                            placeholder="Enter" />
                        <span class="invalid-message"
                            *ngIf="(attorneyInfoForm.get('attorneyNameOfHighestStartCourt').touched && attorneyInfoForm.get('attorneyNameOfHighestStartCourt').errors?.required)">
                            {{ getGlobalErrorMessages("REQUIRED") }}
                        </span>
                </div>
            </div>

        </ng-container>
        
    </form>    
</div>

<!-- Confirm Reset Modal -->
<p-confirmDialog id="confirm-reset-modal" [style]="{width: '35vw'}"></p-confirmDialog>

</mat-expansion-panel>


